import HttpRequest from './HttpRequest';

export const getProfile = async () => {
  try {
    const response = await HttpRequest.get('/profile');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
